import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {ShareModel} from '@/libs/Api';
import {SharesDataService} from '@/libs/shares/shares-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const sharesStore = registerCrudStore<ShareModel, ShareModel>(StoreName.Share, new SharesDataService());
